export default {
    methods: {
        dateFormat: function (fmt, date) {
            var o = {
                "m+": date.getMonth() + 1,     //月份 
                "d+": date.getDate(),     //日 
                "H+": date.getHours(),     //小时 
                "M+": date.getMinutes(),     //分 
                "S+": date.getSeconds(),     //秒 
                "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
                "S": date.getMilliseconds()    //毫秒 
            };
            if (/(y+)/.test(fmt))
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
            for (var k in o)
                if (new RegExp("(" + k + ")").test(fmt))
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
            return fmt;
        },
        downloadExcel: function (dataStr) {
            var bstr = atob(dataStr),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            /*if (window.URL.createObjectURL(blob).indexOf(location.host) < 0) {
              //ie不支持
              this.href = window.navigator.msSaveOrOpenBlob(blob, "export.xlsx");
            } else {
              this.download = "export.xlsx";
              this.href = URL.createObjectURL(blob);
            }
            window.open(this.href);
            console.log(response.data.data);*/
            // 创建一个a链接
            var aTag = document.createElement("a");
            // 给下载文件命名
            aTag.download = "export.xlsx";
            // 创建下载
            aTag.href = URL.createObjectURL(blob);
            // 开始下载
            aTag.click();
            URL.revokeObjectURL(blob);
        },
        isWeiXin: function () {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                return true; // 是微信端
            } else {
                return false;
            }
        },
        getQueryParam: function (key) {
            const reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i');
            const r = window.location.search.substr(1).match(reg);
            console.log(r)
            if (r != null) {
                return decodeURI(r[2]);
            }
            return null;
        },
        setLocale: function (lang) {
            this.$root.$i18n.locale = lang;
            localStorage.setItem("lang", lang);
        },
        isMobile: function () {
          return window.matchMedia("(max-device-width: 960px)").matches;
        }
    }
}


// WEBPACK FOOTER //
// ./src/config/Mixin.js